export default "__VITE_ASSET__Tvo5kIX3__"